import React, { useEffect, useState } from 'react'

import { formatDate, getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'
import { SERVICE_TOKEN_USER_ID } from '../../../common/constants'
import { useGetMeQuery, useLazyGetUserByIdQuery } from '../../../store/user/user'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'
import { AIAgentResult } from '../../../models/AIAgent'
import { User } from '../../../models/User'

interface AIAgentLastUpdatedProps {
  existingAgentResult: AIAgentResult | null
}

export const AIAgentLastUpdated: React.FC<AIAgentLastUpdatedProps> = ({ existingAgentResult }) => {
  const accountId = useAppSelector(selectAccountId)

  const { data: currentUser } = useGetMeQuery({ accountId })

  const [triggerGetUserById] = useLazyGetUserByIdQuery()

  const [updatedByUser, setUpdatedByUser] = useState<User | null>(null)

  useEffect(() => {
    if (!existingAgentResult || !currentUser) {
      return
    }
    const meetingPrepLastUpdatedBy = existingAgentResult.updatedBy.id
    if (meetingPrepLastUpdatedBy === currentUser.id || meetingPrepLastUpdatedBy === SERVICE_TOKEN_USER_ID) {
      return
    }

    const getLastUpdatedByUser = async () => {
      const { data: user } = await triggerGetUserById({ accountId, userId: meetingPrepLastUpdatedBy })
      if (user?.data) {
        setUpdatedByUser(user.data)
      }
    }
    getLastUpdatedByUser()
  }, [accountId, existingAgentResult, currentUser, triggerGetUserById])

  if (!existingAgentResult || !updatedByUser || updatedByUser.id !== existingAgentResult.updatedBy.id) {
    return null
  }

  return (
    <div className='paragraph-small'>
      Last updated at {formatDate(existingAgentResult.updatedAt)} by {getUserDisplayName(updatedByUser)}
    </div>
  )
}
